import React, { useState } from 'react';
import { useAppDispatch } from '../../store/hooks';
import { makeApiRequest, RequestStatus } from '../../api_request/api_request';
import { Valid, RequestStatusDisplay } from '../CommonComponents';
import { Button, Input } from "../RequestRespectingInputs";
import { GetPageTitle } from '../../ErnotsConfig';

export const username_pattern = /^[\w.@+-]+$/;
export const email_pattern = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;

export function UserRegistrationForm()
{
    const appDispatch = useAppDispatch();

    const [username, setUsername] = useState('');

    const [email, setEmail] = useState('');
    const [confirm_email, setConfirmEmail] = useState('');

    const [password, setPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');

    const [request, setRequest] = useState<RequestStatus|undefined>(undefined);

    const formValid = (
    {
        username_pattern: username_pattern.test(username),
        email_pattern: email_pattern.test(email),
        email_match: email === confirm_email,
        passwords_match: password === confirm_password,
    });

    function validate()
    {
        for (var test of Object.values(formValid))
        {
            if (!test) return false;
        }

        return true;
    }

    function handleSubmit(event: React.FormEvent)
    {
        event.preventDefault();
        if (!validate())
        {
            return;
        }
        const userData = { username, email, password, confirm_password };
        makeApiRequest({
            endpoint: 'users/',
            method: 'POST',
            postData: userData,
            dispatch: appDispatch,
            lifeCycleCallback: setRequest,
            useAuthPrefix: true
        });
    };

    const ret = (
        <div>
            <h1>Register</h1>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>Username</label>
                    <Input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        maxLength={150}
                        autoComplete="username"/>
                    <Valid bValid={formValid.username_pattern} children='A username is required.'/>
                </div>
                <div>
                    <label>Email</label>
                    <Input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        autoComplete="email"/>
                    <Valid bValid={formValid.email_pattern} children='An email address is required.'/>
                </div>
                <div>
                    <label>Confirm Email</label>
                    <Input
                        type="email"
                        value={confirm_email}
                        onChange={(e) => setConfirmEmail(e.target.value)}
                        required
                        autoComplete="email"/>
                    <Valid bValid={formValid.email_match} children="The confirmation email doesn't match."/>
                </div>
                <div>
                    <label>Password</label>
                    <Input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        autoComplete="new-password"/>
                    <Valid bValid={password.trim()} children='A password is required.'/>
                </div>
                <div>
                    <label>Confirm Password</label>
                    <Input
                        type="password"
                        value={confirm_password}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        autoComplete="new-password"/>
                    <Valid bValid={formValid.passwords_match} children="The confirmation password doesn't match."/>
                </div>
                <Button type='submit'>Submit</Button>
                <p style={{'color': 'red'}}><b>Note: After registering, you will need to check your mail for an activation letter. You won't be able to log in until you activate it.</b></p>
            </form>
            <RequestStatusDisplay request={request}/>
        </div>
    );

    return (
    <div className='ernots_User ernots_UserRegistrationForm'>
        <title>{GetPageTitle('User Registration Form')}</title>
        {ret}
    </div>);
};